import { render, staticRenderFns } from "./tab-attach-files.vue?vue&type=template&id=a20f662e&"
import script from "./tab-attach-files.vue?vue&type=script&lang=js&"
export * from "./tab-attach-files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports